import {MODEL_FIELD_DISPLAY_NAME} from 'instruments/equipment/EquipmentConstants';
import type {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';
import type {BioentityForProcedure} from 'procedures/utils/useBioentitiesForProcedures';
import {FieldType} from 'schemas/fields/SchemaFieldConstants';
import {EquipmentModelInfo} from 'studies/typed/shared/flowcharts/unit-op-linking/PMEICellColorGrade';

/**
 * Resolves the entity linked by an equipment entity's "Model" field. Returns null for text
 * equipment, an equipment link with no target, an entity that was not fetched, or an entity with no
 * model. Mirrors the tag lookup in `isEquipmentValidWithModel`.
 */
export function getEquipmentModelInfo(
  equipment: TypedValue,
  bioentitiesById: Map<string, BioentityForProcedure>
): EquipmentModelInfo | null {
  if (equipment.type !== FieldType.BIOENTITY_LINK || equipment.targetFiles.length === 0) {
    return null;
  }
  const equipmentEntityId = equipment.targetFiles[0].id;
  if (equipmentEntityId == null) {
    return null;
  }
  const entity = bioentitiesById.get(equipmentEntityId);
  const modelTag = entity?.tags.find((tag) => tag.name === MODEL_FIELD_DISPLAY_NAME);
  const modelTarget = modelTag?.targetFiles?.[0];
  if (modelTarget?.id == null) {
    return null;
  }
  return {modelId: modelTarget.id, modelName: modelTarget.name};
}
